module.exports = __webpack_public_path__ + "assets/img/video_default.0a2cea54.jpg";